<template>
    <v-dialog v-model="dialog" fullscreen>
      <v-layout fill-height column @click.stop="dialog = false" wrapper>
        <v-card v-if="file" class="viewer" dark @click.native.stop>

          <v-layout column>
            <v-card-title>
              <v-flex subheading>{{ file.title }}</v-flex>
              <v-flex controls>

                <template v-if="files.length > 1">
                  <v-btn icon dark flat small @click="prevFile" :disabled="this.current === 0"><v-icon data-recite-skip="true">chevron_left</v-icon></v-btn>
                  <span class="d-inline-flex mx-3">{{this.current + 1}} / {{ this.files.length }}</span>
                  <v-btn icon dark flat small @click="nextFile" :disabled="this.files.length - 1 === this.current"><v-icon data-recite-skip="true">chevron_right</v-icon></v-btn>
                </template>

                <v-btn icon flat dark small @click="dialog = false" class="hidden-md-and-up"><v-icon data-recite-skip="true">close</v-icon></v-btn>
                <v-btn flat dark small @click="dialog = false" class="hidden-sm-and-down"><v-icon left data-recite-skip="true">close</v-icon>{{ t('Close') }}</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text class="viewer-preview">
              <component v-if="dialog" :is="viewer" :file="file"></component>
            </v-card-text>
          </v-layout>

        </v-card>
      </v-layout>
    </v-dialog>
</template>

<script>
  export default {
    name: 'App',
    components: {
      PdfViewer: () => import('@/components/PdfViewer'),
      NotSupported: () => import('@/components/NotSupported'),
      ImgViewer: () => import('@/components/ImageViewer'),
    },
    data () {
      return {
        files: [],
        current: null,
        dialog: false,
      }
    },
    props: {
      items: {
        type: Array,
        required: true
      }
    },

    mounted () {
      this.items.map( (item, key) => {
        let title = item.getAttribute('title') || item.getAttribute('alt')
        ,   href = item.getAttribute('href') || item.getAttribute('src')

        if (!title) {
          title = decodeURIComponent(href.split('/').pop().split('?').shift().split('.').shift())
        }

        const file = {
          url: href,
          mime: item.getAttribute('mime') || item.getAttribute('type') || this.extensionToMime(href),
          title: title
        }

        this.files.push(file)

        item.addEventListener('click', (e) => {
          this.dialog = true
          this.current = key
          e.preventDefault()
        })
      })
    },

    computed: {
      file () {
        return this.files[this.current]
      },

      viewer () {
        if (!this.file.url) return

        switch (this.file.mime) {
          case 'application/pdf':
            return 'PdfViewer'

          case 'image/png':
          case 'image/jpeg':
          case 'image/gif':
          case 'image/bmp':
          case 'image/pjpeg':
          case 'image/tiff':
          case 'image/webp':
            return 'ImgViewer'

          default:
            return 'NotSupported'
        }
      }
    },

    methods: {
      t: Drupal.t,

      nextFile () {
        this.current++
      },

      prevFile () {
        this.current--
      },

      extensionToMime (href) {
        let ext = decodeURI(href).split('?').shift().split('.').pop().toLowerCase()

        switch (ext) {
          case 'pdf':
            return 'application/pdf'

          case 'png':
          case 'gif':
          case 'tiff':
          case 'bmp':
          case 'webp':
            return 'image/' + ext

          case 'jpeg':
          case 'jpg':
            return 'image/jpeg'
        }
      }
    }
  }
</script>
